import * as React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import ListSubheader from '@mui/material/ListSubheader';
import Tooltip from '@mui/material/Tooltip';

// Updated icon imports with suggested alternatives
import HomeIcon from '@mui/icons-material/Home';
import TravelExploreIcon from '@mui/icons-material/TravelExplore'; // Replacement for EditIcon
import PeopleAltIcon from '@mui/icons-material/PeopleAlt'; // Alternative to GroupIcon
import LayersIcon from '@mui/icons-material/Layers'; // Alternative to CategoryIcon
import NoteAddIcon from '@mui/icons-material/NoteAdd'; // Alternative to AddCircleIcon

import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import TimelineIcon from '@mui/icons-material/Timeline';
import EventIcon from '@mui/icons-material/Event';

export const MainMenuItems = (
	<React.Fragment>
		<ListItemButton component={RouterLink} to="/">
			<ListItemIcon>
				<Tooltip title="Home">
					<HomeIcon />
				</Tooltip>
			</ListItemIcon>
			<ListItemText primary="Home" />
		</ListItemButton>
		<ListItemButton component={RouterLink} to="/characters">
			<ListItemIcon>
				<Tooltip title="All Characters">
					{/* Using PeopleAltIcon to signify a modern grouping */}
					<PeopleAltIcon />
				</Tooltip>
			</ListItemIcon>
			<ListItemText primary="All Characters" />
		</ListItemButton>
		<ListItemButton component={RouterLink} to="/character_templates">
			<ListItemIcon>
				<Tooltip title="Character Templates">
					{/* Using LayersIcon as a metaphor for building character templates */}
					<LayersIcon />
				</Tooltip>
			</ListItemIcon>
			<ListItemText primary="Character Templates" />
		</ListItemButton>
		<ListItemButton component={RouterLink} to="/character_template">
			<ListItemIcon>
				<Tooltip title="Create Character Template">
					{/* Using NoteAddIcon for creating new items */}
					<NoteAddIcon />
				</Tooltip>
			</ListItemIcon>
			<ListItemText primary="Create Character Template" />
		</ListItemButton>
	</React.Fragment>
);

export const secondaryListItems = (
	<React.Fragment>
		<ListSubheader component="div" inset>
			Saved reports
		</ListSubheader>
		<ListItemButton>
			<ListItemIcon>
				<Tooltip title="Current Month">
					<CalendarMonthIcon />
				</Tooltip>
			</ListItemIcon>
			<ListItemText primary="Current month" />
		</ListItemButton>
		<ListItemButton>
			<ListItemIcon>
				<Tooltip title="Last Quarter">
					<TimelineIcon />
				</Tooltip>
			</ListItemIcon>
			<ListItemText primary="Last quarter" />
		</ListItemButton>
		<ListItemButton>
			<ListItemIcon>
				<Tooltip title="Year-End Sale">
					<EventIcon />
				</Tooltip>
			</ListItemIcon>
			<ListItemText primary="Year-end sale" />
		</ListItemButton>
	</React.Fragment>
);
